import { Link, useNavigate } from "react-router-dom";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { useState, useEffect } from "react";
import { AddPartner } from "../../api/api";
import { GetPartner } from "../../api/get";
import Loader from "../../loader";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "../../Common/Spinner";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaAngleRight, FaInfoCircle } from "react-icons/fa";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import Header from "../../Common/Header";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { handleApiError } from "../../Common/Helper";
const YourPartner = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");
  const [isFocused, setIsFocused] = useState(false);
  const [errors, setErrors] = useState({});
  const [partner, setPartner] = useState({});
  const [contentLoder, setContentLoader] = useState(true);
  useEffect(() => {
    // Fetch personal details and relationships and set form values once loaded
    Promise.all([GetPartner()])
      .then(([partner]) => {
        if (partner.success && partner.status_code === "200") {
          setPartner(partner.data);
          setContentLoader(false);
        } else {
          handleApiError(partner, navigate); // Use helper function
        }
      })
      .catch((err) => console.error("Error fetching data", err));
  }, []);
  console.log("partner=>", partner);
  // Yup validation schema
  const validationSchema = Yup.object().shape({
    beneficiary_first_name: Yup.string().required("Required field"),
    beneficiary_last_name: Yup.string().required("Required field"),
    beneficiary_email: Yup.string().email("Invalid email address"),
    beneficiary_dob: Yup.string()
      .nullable()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      )
      .test(
        "is-over-18",
        "Sorry, but your partner needs to be over 18.",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          const enteredDate = new Date(`${year}-${month}-${day}`);
          const today = new Date();
          const age = today.getFullYear() - enteredDate.getFullYear();
          const isBirthdayPassed =
            today.getMonth() > enteredDate.getMonth() ||
            (today.getMonth() === enteredDate.getMonth() &&
              today.getDate() >= enteredDate.getDate());
          return age > 18 || (age === 18 && isBirthdayPassed);
        }
      ),
  });

  const formik = useFormik({
    initialValues: {
      beneficiary_first_name: partner?.beneficiary_first_name || "",
      beneficiary_last_name: partner?.beneficiary_last_name || "",
      beneficiary_email: partner?.beneficiary_email || "",
      beneficiary_dob: partner?.beneficiary_dob
        ? new Date(partner.beneficiary_dob).toLocaleDateString("en-GB")
        : "",
      is_partner_leave_at_user_location:
        partner?.is_partner_leave_at_user_location,
      beneficiary_location: partner?.beneficiary_location || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      // Convert beneficiary_dob to "yyyy-mm-dd" format
      if (values.beneficiary_dob) {
        const [day, month, year] = values.beneficiary_dob.split("/");
        values.beneficiary_dob = `${year}-${month}-${day}`;
      }
      // Convert `is_partner_leave_at_user_location` to 1 or 0
      values.is_partner_leave_at_user_location =
        values.is_partner_leave_at_user_location ? 1 : 0;

      console.log("Formatted Values =>", values);
      // setLoading(true);
      AddPartner(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Partner added successfully");
            setLoading(false);
            // navigate("/make-will-online/about-yourself/children");
          } else {
            handleApiError(res,navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  // Watch formik.errors to reset loading state
  useEffect(() => {
    if (Object.keys(formik.errors).length > 0) {
      setLoading(false);
    }
  }, [formik.errors]);
  return (
    <>
      {contentLoder ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 max-lg:grid-cols-1">
              <div>
                <div>
                  <form onSubmit={formik.handleSubmit}>
                    <div>
                      <h4 className="text-black font-bold mt-[25px] text-[26px] sm:text-[30px] lg:text-[34px]">
                        Your partner
                      </h4>
                      <p className="text-slate-500 my-2">
                        Adding your partner is optional, you can choose whether
                        to add their details or not. Learn more about{" "}
                        <a href="" className="underline font-bold">
                          how partner wills work.
                        </a>
                      </p>
                    </div>
                    <div className="grid grid-cols-2 gap-5 ">
                      <div className="mt-5 mb-4 ">
                        <FloatingLabelInput
                          label="First Name"
                          type="text"
                          id="beneficiary_first_name"
                          name="beneficiary_first_name"
                          value={formik.values.beneficiary_first_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.beneficiary_first_name &&
                            formik.errors.beneficiary_first_name
                          }
                        />
                      </div>
                      <div className="mt-5 mb-4 ">
                        <FloatingLabelInput
                          label="Last Name"
                          type="text"
                          id="beneficiary_last_name"
                          name="beneficiary_last_name"
                          value={formik.values.beneficiary_last_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.beneficiary_last_name &&
                            formik.errors.beneficiary_last_name
                          }
                        />
                      </div>
                    </div>
                    <div className="mt-1 mb-4 ">
                      <FloatingLabelInput
                        label="Partner's email address (optional)"
                        type="text"
                        id="beneficiary_email"
                        name="beneficiary_email"
                        value={formik.values.beneficiary_email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.beneficiary_email &&
                          formik.errors.beneficiary_email
                        }
                      />
                    </div>
                    <div className="w-full mt-5">
                      <div className="relative w-full border-2 h-[60px] flex items-center">
                        <MaskedInput
                          mask={[
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          placeholder={
                            isFocused || formik.values.beneficiary_dob
                              ? "dd/mm/yyyy"
                              : ""
                          }
                          pipe={autoCorrectedDatePipe}
                          value={formik.values.beneficiary_dob}
                          onFocus={() => setIsFocused(true)}
                          onBlur={(e) => {
                            setIsFocused(false);
                            formik.handleBlur(e); // To ensure Formik registers field as "touched"
                          }}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "beneficiary_dob",
                              e.target.value
                            );
                          }}
                          className="block text-black w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer border-red-500 focus:border-red-500"
                          name="beneficiary_dob"
                        />

                        <label
                          htmlFor="dob"
                          className="absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                        >
                          Date of birth(optional)
                        </label>
                      </div>
                    </div>
                    {formik.touched.beneficiary_dob &&
                    formik.errors.beneficiary_dob ? (
                      <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                        <FaInfoCircle />
                        <p className="text-white py-1 px-2 text-sm my-2">
                          {formik.errors.beneficiary_dob}
                        </p>
                      </div>
                    ) : null}

                    <div>
                      <h4 className="text-[16px] text-black font-bold mt-[36px]">
                        Add their address
                      </h4>
                      <p className="text-slate-500 my-2">
                        Adding address is optional
                      </p>
                    </div>
                    <div className="mt-1 mb-4 ">
                      <FloatingLabelInput
                        label="Enter their full address"
                        type="text"
                        id="beneficiary_location"
                        name="beneficiary_location"
                        value={formik.values.beneficiary_location}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                    <div className="mt-5">
                      <label className="inline-flex items-center">
                        <input
                          type="checkbox"
                          className="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out"
                          checked={
                            formik.values.is_partner_leave_at_user_location
                          }
                          onChange={() =>
                            formik.setFieldValue(
                              "is_partner_leave_at_user_location",
                              !formik.values.is_partner_leave_at_user_location
                            )
                          }
                        />
                        <span className="ml-2 text-gray-700">
                          Partner leave at user location
                        </span>
                      </label>
                    </div>
                    <div className="mt-5 flex justify-end">
                      <div>
                        <button
                          type="submit"
                          onClick={() => setLoading(true)}
                          className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1"
                        >
                          {loading ? "Saving..." : "Save"}{" "}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="border-b-2 my-5"></div>
                <div className="flex justify-between my-3">
                  <Link
                    to={
                      "/make-will-online/about-yourself/edit-personal-details"
                    }
                  >
                    <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] mt-5 text-slate-500">
                      <FaAngleLeft />
                      Back
                    </button>
                  </Link>
                  <Link to={"/make-will-online/about-yourself/children"}>
                    <button className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1">
                      Next
                      <FaAngleRight />
                    </button>
                  </Link>
                </div>
              </div>
              <div className="max-lg:hidden bg-no-repeat">
                <div className="fixed top-0 w-[500px] right-[6%] bg-cloud">
                  <img src="/assets/images/4.png" alt="mascot" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default YourPartner;
